<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="crm-color" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>
        <div class="buttons-tab"></div>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <div class="preview-list">
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.ID") }}:</span>
                  <span class="preview-value">{{ requestData.id || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.NAME") }}:</span>
                  <span class="preview-value">{{ requestData.name || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">Rank:</span>
                  <span class="preview-value">{{ requestData.rank?.name ?? "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">Types:</span>
                  <span class="preview-value">{{ requestData.types?.map(type => type.name).join(", ") }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.STATUS") }}:</span>
                  <span class="preview-value">
                    <v-chip
                      x-small
                      :color="requestData.active ? 'success' : 'error'"
                      dark
                    >
                      {{ requestData.active ? $t("GENERAL.LABELS.ACTIVE") : $t("GENERAL.LABELS.INACTIVE") }}
                    </v-chip>
                  </span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.COMPANY_CONTACTS_COUNT") }}:</span>
                  <span class="preview-value">
                    <router-link
                      v-if="requestData.id && hasPermissions('company-contacts-view-all')"
                      :to="{ name: 'company-contacts', query: { company_id: requestData.id } }"
                      class="primary--text"
                    >
                      {{ requestData.company_contacts_count ?? 0 }}
                    </router-link>
                    <span v-else>{{ requestData.company_contacts_count ?? 0 }}</span>
                  </span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.VAT") }}:</span>
                  <span class="preview-value">{{ requestData.vat || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.CREDIT_LIMIT") }}:</span>
                  <span class="preview-value">{{ requestData.credit_limit ?? "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.WEBSITE") }}:</span>
                  <span class="preview-value">{{ requestData.website || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.COUNTRY") }}:</span>
                  <span class="preview-value">{{ requestData.country?.label ?? requestData.country?.name ?? "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.OWNED_BY") }}:</span>
                  <span class="preview-value">{{ requestData.owner?.name ?? "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.ADDRESS") }}:</span>
                  <span class="preview-value">{{ requestData.address || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("COMPANIES.NOTES") }}:</span>
                  <span class="preview-value">{{ requestData.notes || "-" }}</span>
                </div>
                <div class="preview-row preview-row--stacked">
                  <span class="preview-label">{{ $t("COMPANIES.GENERAL_EMAILS") }}:</span>
                  <div class="preview-value">
                    <template v-if="requestData.general_emails?.length">
                      <div
                        v-for="generalEmail in requestData.general_emails"
                        :key="generalEmail.id"
                        class="general-email-item"
                      >
                        <div>{{ generalEmail.email }}</div>
                        <div v-if="generalEmail.tags?.length" class="general-email-tags">
                          <v-chip
                            v-for="tag in generalEmail.tags"
                            :key="tag.id || tag.value"
                            x-small
                            class="mr-1 mb-1"
                          >
                            {{ tag.value }}
                          </v-chip>
                        </div>
                      </div>
                    </template>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { GET_COMPANY } from "@/store/companies.module";
import { SHOW_SNACK } from "@/store/snack.module";

export default {
  name: "ViewCompany",
  data() {
    return {
      title: this.$t("COMPANIES.VIEW"),
      tab: "tab-1",
      isProcessing: false,
      requestData: {},
    };
  },
  mounted() {
    this.selectCompany();
  },
  methods: {
    back() {
      this.$router.push({ name: "companies" });
    },
    selectCompany() {
      this.isProcessing = true;
      this.$store
        .dispatch(GET_COMPANY, this.$route.params.id)
        .then((response) => {
          this.requestData = response;
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>

<style scoped>
.preview-row--stacked {
  align-items: flex-start;
}

.general-email-item + .general-email-item {
  margin-top: 12px;
}

.general-email-tags {
  margin-top: 4px;
}
</style>
